import { Box, Grid, TextField, Button } from "@mui/material"
import {
  Body,
} from "../../screens/Login/Login.styles"
export default function ForgotPassword({email, handleForgotPwEmailChange, errorsEmail, useForgotPwdSubmitMutation}) {

    return(
        <Box  sx={{width: '100%', margin: '0 auto', minHeight: `calc(100vh - 320px)`}}>
            <Body sx={{fontSize: '20px', fontWeight: 800, color: "#111", marginBottom: 1}}>Forgot your password?</Body>
            <Body sx={{fontSize: '14px', color: "111",  marginTop: '5px'}}>Enter the email address you used to sign in.</Body>
            <Grid sx={{ marginBottom: '20px',}}>
                <TextField
                    label={!email ? "Email address" : undefined}
                    value={email}
                    name="email"
                    onChange={handleForgotPwEmailChange}
                    fullWidth
                    required
                    error={!!errorsEmail}
                    helperText={errorsEmail}
                    InputProps={{
                        sx: {
                        backgroundColor: 'white'
                        }
                    }}
                />
            </Grid>
            <Grid sx={{ marginBottom: '20px', }}>
                <Button
                    type="submit"
                    variant="contained"
                    disabled={useForgotPwdSubmitMutation.isPending}
                    sx={{width: '100%'}}
                >
                    {useForgotPwdSubmitMutation.isPending ? "Loading..." : "Reset Password"}
                </Button>
            </Grid>
        </Box>
    );
}